<modal-layout-right (close)="close()"
                    [lockScrollSpace]="client.sizeId < 2">
    <ng-container ngProjectAs="[modalTitle]">
        <h4 class="h3">{{'Select Product' | translate}}</h4>
    </ng-container>

    <div modalBody
         class="p-a p-t-5"
         [style.width]="client.sizeId > 1 ? '480px' : '100%'">
        <builder-product-preview [model]="data.product"
                                 [existingSelection]="currentSelectionData"
                                 (selectionChange)="onSelectionChange($event.selection)"></builder-product-preview>
    </div>

    <!-- filter buttons -->
    <div modalFooter
         class="w-12 p-a flex">
        <!-- clear -->
        <button class="button-1 m-r-1 w-6"
                (click)="close()">
            <span class="button__body">{{'Cancel' | translate}}</span>
        </button>

        <!-- close -->
        <button class="button m-l-1 w-6"
                (click)="confirm()"
                [disabled]="!canConfirm">
            <span class="button__body">{{(displaySelectSize ? 'Select size' : 'Confirm') | translate}}</span>
        </button>
    </div>
</modal-layout-right>
